import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { gamesApi } from '../services/api';
import DealerGameControl from './DealerGameControl';

export default function DealerGameControlRoute({ username, userId, userLocation, onLogout }) {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const [game, setGame] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await gamesApi.getGameSeating(gameId);
        const data = res.data || res;
        if (cancelled) return;
        // Build minimal game object DealerGameControl expects
        setGame({
          id: gameId,
          venue: data.game?.venue || data.venue || {},
          startTime: data.game?.startTime || data.startTime,
          leagueTimezone: data.game?.leagueTimezone,
          maxPlaces: data.game?.maxPlaces,
        });
      } catch (e) {
        setError(e.message || 'Failed to load game');
      }
    })();
    return () => { cancelled = true; };
  }, [gameId]);

  if (error) return <div style={{ padding: 24, color: '#fff', background: '#0d1929', minHeight: '100vh' }}>
    <p>{error}</p>
    <button onClick={() => navigate('/dealer-hub')}>Back</button>
  </div>;
  if (!game) return <div style={{ padding: 24, color: '#fff', background: '#0d1929', minHeight: '100vh' }}>Loading game…</div>;

  return (
    <DealerGameControl
      username={username}
      userId={userId}
      userLocation={userLocation}
      game={game}
      onBackToGames={() => navigate('/dealer-hub')}
      onLogout={onLogout}
    />
  );
}
